// extracted by mini-css-extract-plugin
export default {"genericBtn":"Generic_genericBtn__s64zq","btn":"Generic_btn__A0hFy","logo":"Generic_logo__ffetq","smallText":"Generic_smallText__P+wGX","titleText":"Generic_titleText__TV4bo"};